var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"position-absolute card card-div w-95",class:_vm.cardClass,attrs:{"tabindex":"-1"},on:{"mousedown":_vm.eventPrevent}},[_vm._t("card")],2),_vm._t("outer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }